import React, { FC } from 'react';

import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { makeMuiCustomStyles, muiThemeLuma } from 'embeds/themes';
import { getCustomStyles } from 'embeds/utils/getCustomStyles';

import { useEmbedor } from '../utils';

import EmbedError from './EmbedError/EmbedError';
import EmbedorWrapper from './EmbedorWrapper';
import PageLoader from './PageLoader';

interface Props {}

const Embedor: FC<Props> = ({ children }) => {
  const { embedTheme, embedFontFamilyCDN, appIsReady, isLoading, isError } = useEmbedor();

  let muiTheme = muiThemeLuma;
  if (embedTheme) {
    muiTheme = makeMuiCustomStyles(getCustomStyles(embedTheme));
  }

  if (!appIsReady || isLoading) {
    return <PageLoader />;
  }

  if (isError) {
    return <EmbedError />;
  }

  return (
    <>
      <MuiThemeProvider theme={muiTheme}>
        <CssBaseline />
        {embedFontFamilyCDN && <link href={embedFontFamilyCDN} rel="stylesheet" />}
        <EmbedorWrapper>{children}</EmbedorWrapper>
      </MuiThemeProvider>
    </>
  );
};

export default Embedor;
